import { gql } from "@apollo/client";export default gql`mutation deleteTab($id: Int!) {
    deleteTab: delete_home_explore_tab_by_pk(id: $id) {
        id
    }
}
`;
